<template>
  <div
    class="bl-input-component"
    :class="
      `${focused ? 'bl-input-focus' : ''} ${
        input.disabled ? 'bl-input-disabled' : ''
      }`
    "
    :data-id="input.id"
  >
    <label
      v-if="input.label"
      :for="id"
      :data-id="input.id"
      class="bl-input-label"
    >
      {{ input.label }}
      <span v-if="input.asterisk" class="text-error-400 text-xl absolute -top-2 ml-1">*</span>
    </label
    >
    <BlIcon
      v-if="icon"
      icon="timer"
      class="bl-input-icon"
      :color="focused ? 'primary' : ''"
    />
    <div
      v-if="!input.format || input.format.includes('h')"
      class="bl-input-wrapper"
      :class="{ 'bl-input-wrapper-icon': icon }"
    >
      <input
        v-if="!input.format || input.format.includes('h')"
        type="number"
        class="bl-input"
        maxlength="2"
        :id="id"
        placeholder="--"
        :data-id="input.id"
        :disabled="input.disabled"
        v-model="value.hours"
        @focusin="focused = true"
        @blur="focused = false"
        @input="change"
      />
      <div
        v-if="!input.format || input.format.includes('m')"
        class="bl-input-divider"
      >
        <BlTextBody2 text=":" />
      </div>
      <input
        v-if="!input.format || input.format.includes('m')"
        type="number"
        class="bl-input"
        maxlength="2"
        :id="`${id}-2`"
        placeholder="--"
        :data-id="input.id"
        :disabled="input.disabled"
        v-model="value.minutes"
        @focusin="focused = true"
        @blur="focused = false"
        @input="change"
      />
      <div
        v-if="!input.format || input.format.includes('s')"
        class="bl-input-divider"
      >
        <BlTextBody2 text=":" />
      </div>
      <input
        v-if="!input.format || input.format.includes('s')"
        type="number"
        class="bl-input"
        maxlength="2"
        :id="`${id}-3`"
        placeholder="--"
        :data-id="input.id"
        :disabled="input.disabled"
        v-model="value.seconds"
        @focusin="focused = true"
        @blur="focused = false"
        @input="change"
      />
    </div>
    <div class="bl-input-border"></div>
  </div>
</template>

<script>
import BlIcon from "./BlIcon.vue";
import BlTextBody2 from "./BlTextBody2.vue";
export default {
  components: { BlIcon, BlTextBody2 },
  props: {
    icon: { type: Boolean, default: true },
    input: {
      model: {
        type: String,
        required: true
      },
      label: {
        type: String,
        required: false
      },
      disabled: {
        type: Boolean,
        required: false
      },
      format: {
        type: ["h" | "m" | "s"],
        required: false
      },
      id: {
        type: String,
        required: false
      }
    }
  },
  data() {
    return {
      value: {
        hours: "",
        minutes: "",
        seconds: ""
      },
      focused: false
    };
  },
  computed: {
    id() {
      const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
      let combination = "";
      for (let i = 0; i < 6; i++) {
        combination += chars[Math.round(Math.random() * 35)];
      }
      return `bl-input-${combination}`;
    }
  },
  watch: {
    input: {
      deep: true,
      immediate: true,
      handler(val) {
        if (val.model) {
          let hours, minutes, seconds;
          const value = val.model.split(":");
          if (val.format) {
            hours = value[val.format.indexOf("h")];
            minutes = value[val.format.indexOf("m")];
            seconds = value[val.format.indexOf("s")];
          } else {
            hours = value[0];
            minutes = value[1];
            seconds = value[2];
          }
          this.value = {
            hours,
            minutes,
            seconds
          };
        }
      }
    }
  },
  methods: {
    change() {
      let { hours, minutes, seconds } = this.value;
      hours = parseInt(hours);
      minutes = parseInt(minutes);
      seconds = parseInt(seconds);
      if (hours > 99) hours = "99";
      else if (hours < 0 || !hours) hours = "00";
      else hours = hours.toString().padStart(2, "0");
      if (minutes > 59) minutes = "59";
      else if (minutes < 0 || !minutes) minutes = "00";
      else minutes = minutes.toString().padStart(2, "0");
      if (seconds > 59) seconds = "59";
      if (seconds < 0 || !seconds) seconds = "00";
      else seconds = seconds.toString().padStart(2, "0");
      this.value = {
        hours,
        minutes,
        seconds
      };
      if (!this.disabled) {
        if (this.input.format) {
          const val = [];
          const hi = this.input.format.indexOf("h");
          const mi = this.input.format.indexOf("m");
          const si = this.input.format.indexOf("s");
          if (hi > -1) val[hi] = hours;
          if (mi > -1) val[mi] = minutes;
          if (si > -1) val[si] = seconds;
          this.$emit("changed", {
            input: this.input,
            value: val.join(":")
          });
        } else {
          this.$emit("changed", {
            input: this.input,
            value: `${hours}:${minutes}:${seconds}`
          });
        }
      }
    }
  }
};
</script>

<style scoped lang="scss">
.bl-input-component {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  .bl-input-label {
    position: relative;
    font-size: 0.75rem;
    font-weight: 400;
    line-height: calc(5 / 3);
    letter-spacing: 0.5px;
    margin-bottom: 0.25rem;
    padding: 0;
    & ~ .bl-input-border {
      top: 1.5rem;
    }
  }
  .bl-input-wrapper {
    position: relative;
    width: 100%;
    height: 100%;
    padding: 0 1rem;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    gap: 0.25rem;
    &.bl-input-wrapper-icon {
      padding: 0 1rem 0 3.5rem;
    }
    .bl-input {
      position: relative;
      width: 1rem;
      height: 2.5rem;
      padding: 0;
      font-size: 0.875rem;
      font-weight: 400;
      line-height: calc(11 / 7);
      text-align: center;
      letter-spacing: 0.5px;
      box-sizing: border-box;
      flex-shrink: 0;
      &:focus {
        outline: none;
      }
      &::-webkit-inner-spin-button,
      &::-webkit-outer-spin-button {
        display: none;
      }
    }
    .bl-input-divider {
      position: relative;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .bl-input-border {
    pointer-events: none;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 2.5rem;
    border-radius: 5px;
    box-sizing: border-box;
    border: 1px solid var(--border-color);
  }
  .bl-input-icon {
    z-index: 2;
    pointer-events: none;
    position: absolute;
    bottom: 0.5rem;
    left: 1rem;
    width: 1.5rem;
    height: 1.5rem;
  }
  &.bl-input-disabled {
    pointer-events: none;
    opacity: 0.5;
  }
  &.bl-input-focus {
    .bl-input-border {
      border-color: var(--primary-color);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/BlInputTime.vue